
















































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Order } from '@/models/order';
@Component
export default class TrackingProgress extends Vue {
    @Prop({default: null})
    private order!: Order;
}
